var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Grid, Input, Select } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { CatalogOrganismCustomTargetUnpurifiedProbeLot, CatalogUnpurifiedProbeLot, validationTypes, } from "./ProbeLotTablePage";
import { probeLotStatus } from "./CreateNewUnpurifiedProbeLotModal";
var EditUnpurifiedProbeLotModal = /** @class */ (function (_super) {
    __extends(EditUnpurifiedProbeLotModal, _super);
    function EditUnpurifiedProbeLotModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onStatusChange = function (event, data) {
            var str = data.value;
            _this.setState({ status: str });
        };
        _this.onValidationChange = function (event, data) {
            var str = data.value;
            _this.setState({ validation: str });
        };
        _this.onOrderedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ orderedDate: str });
        };
        _this.onReceivedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ receivedDate: str });
        };
        _this.onYieldChange = function (event, data) {
            var str = data.value;
            var num = parseFloat(str);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ yield: num });
        };
        _this.onCurrentInventoryChange = function (event, data) {
            var str = data.value;
            var num = parseFloat(str);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ currentInventory: num });
        };
        _this.onDeactivateChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    deactivated: !oldState.deactivated
                };
            });
        };
        _this.onReasonForDeactivationExplanationChange = function (_, data) {
            _this.setState({
                reasonForDeactivation: data.value
            });
        };
        _this.submit = function () {
            _this.props.postRequest("/rna/probe-lot/edit/unpurified/id/" + encodeURIComponent(_this.props.probeLot.id), {
                deactivated: _this.state.deactivated,
                reasonForDeactivation: _this.state.reasonForDeactivation,
                poNumber: _this.state.poNumber,
                supplier: _this.state.supplier,
                createdDate: _this.state.createdDate,
                lotYield: _this.state.yield,
                currentInventory: _this.state.currentInventory,
                status: _this.state.status,
                orderedDate: _this.state.orderedDate,
                receivedDate: _this.state.receivedDate,
                validation: _this.state.validation
            });
        };
        _this.state = {
            deactivated: _this.props.probeLot.deactivated,
            reasonForDeactivation: _this.props.probeLot.reasonForDeactivation,
            poNumber: _this.props.probeLot.params.poNumber,
            supplier: _this.props.probeLot.params.supplier || undefined,
            createdDate: _this.props.probeLot.params.createdDate || undefined,
            status: _this.props.probeLot.params.status,
            orderedDate: _this.props.probeLot.params.orderedDate ? _this.props.probeLot.params.orderedDate : undefined,
            receivedDate: _this.props.probeLot.params.receivedDate ? _this.props.probeLot.params.receivedDate : undefined,
            validation: _this.props.probeLot.validation,
            yield: _this.props.probeLot.params.lotYield ? _this.props.probeLot.params.lotYield : undefined,
            currentInventory: _this.props.probeLot.params.currentInventory ? _this.props.probeLot.params.currentInventory : undefined,
        };
        return _this;
    }
    EditUnpurifiedProbeLotModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.status === 'CREATED' && prevState.status !== 'CREATED') {
            this.setState({ createdDate: prevState.createdDate || new Date().toISOString().split('T')[0] });
        }
        if (this.state.status === 'ORDERED' && prevState.status !== 'ORDERED') {
            this.setState({
                orderedDate: prevState.orderedDate || new Date().toISOString().split('T')[0],
                poNumber: prevState.poNumber,
                supplier: prevState.supplier
            });
        }
        if (this.state.status === 'RECEIVED' && prevState.status !== 'RECEIVED') {
            this.setState({ receivedDate: prevState.receivedDate || new Date().toISOString().split('T')[0] });
        }
    };
    EditUnpurifiedProbeLotModal.prototype.render = function () {
        var _this = this;
        var probeLotType;
        if (this.props.probeLot instanceof CatalogUnpurifiedProbeLot) {
            probeLotType = 1;
        }
        else if (this.props.probeLot instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) {
            probeLotType = 2;
        }
        else {
            probeLotType = 3;
        }
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/lotNumber', labelContent: 'Probe Lot Number' },
                React.createElement(Input, { value: this.props.probeLot.lotNumber, disabled: true })),
            probeLotType === 1 &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeLotType', labelContent: 'Probe Lot Type' },
                        React.createElement(Input, { value: 'Catalog Entry', disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organism', labelContent: 'Organism' },
                        React.createElement(Input, { value: this.props.probeLot.organism, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Gene Symbol' },
                        React.createElement(Input, { value: this.props.probeLot.geneSymbol, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: 'Accession' },
                        React.createElement(Input, { value: this.props.probeLot.accession, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: 'Sequence' },
                        React.createElement(Input, { value: this.props.probeLot.sequence, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Amplifier' },
                        React.createElement(Input, { value: this.props.probeLot.hcrAmplifier.id, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSize', labelContent: 'Probe Size' },
                        React.createElement(Input, { value: this.props.probeLot.probeSetSize, disabled: true }))),
            probeLotType === 2 &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeLotType', labelContent: 'Probe Lot Type' },
                        React.createElement(Input, { value: 'Catalog Organism Custom Target', disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organism', labelContent: 'Organism' },
                        React.createElement(Input, { value: this.props.probeLot.organism, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Custom Gene Symbol' },
                        React.createElement(Input, { value: this.props.probeLot.customGeneSymbolName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: 'Custom Accession' },
                        React.createElement(Input, { value: this.props.probeLot.customAccession, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: 'Custom Sequence' },
                        React.createElement(Input, { value: this.props.probeLot.customSequence, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customVariantName', labelContent: 'Custom Variant Name' },
                        React.createElement(Input, { value: this.props.probeLot.customVariantName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Custom Amplifier' },
                        React.createElement(Input, { value: this.props.probeLot.hcrAmplifier.id, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSize', labelContent: 'Custom Probe Size' },
                        React.createElement(Input, { value: this.props.probeLot.customProbeSetSize, disabled: true }))),
            probeLotType === 3 &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeLotType', labelContent: 'Probe Lot Type' },
                        React.createElement(Input, { value: 'Custom', disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organism', labelContent: 'Custom Organism' },
                        React.createElement(Input, { value: this.props.probeLot.customOrganismName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Custom Gene Symbol' },
                        React.createElement(Input, { value: this.props.probeLot.customGeneSymbolName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: 'Custom Accession' },
                        React.createElement(Input, { value: this.props.probeLot.customAccession, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: 'Custom Sequence' },
                        React.createElement(Input, { value: this.props.probeLot.customSequence, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customVariantName', labelContent: 'Custom Variant Name' },
                        React.createElement(Input, { value: this.props.probeLot.customVariantName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Custom Amplifier' },
                        React.createElement(Input, { value: this.props.probeLot.hcrAmplifier.id, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSize', labelContent: 'Custom Probe Size' },
                        React.createElement(Input, { value: this.props.probeLot.customProbeSetSize, disabled: true }))),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/status', labelContent: 'Probe Lot Status' },
                React.createElement(Select, { options: probeLotStatus.map(function (s) {
                        return {
                            text: s,
                            value: s
                        };
                    }), placeholder: this.props.probeLot.params.status, onChange: this.onStatusChange, value: this.state.status, disabled: !!(this.props.probeLot.params.lotYield) })),
            this.state.status === 'CREATED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/createdDate', labelContent: 'Created Date' },
                    React.createElement(Input, { onChange: function (_, data) { return _this.setState({ createdDate: data.value }); }, placeholder: 'Date', type: "date", value: this.state.createdDate })),
            this.state.status === 'ORDERED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/orderedDate', labelContent: 'Ordered Date' },
                    React.createElement(Input, { onChange: this.onOrderedDateChange, placeholder: 'Date', type: "date", value: this.state.orderedDate })),
            this.state.status === 'RECEIVED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/receivedDate', labelContent: 'Received Date' },
                    React.createElement(Input, { onChange: this.onReceivedDateChange, placeholder: 'Date', type: "date", defaultValue: new Date().toISOString().split('T')[0], value: this.state.receivedDate, disabled: !!this.props.probeLot.params.lotYield })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/validation', labelContent: 'Validation' },
                React.createElement(Select, { options: validationTypes.map(function (v) {
                        return {
                            text: v,
                            value: v
                        };
                    }), placeholder: this.props.probeLot.validation, onChange: this.onValidationChange, value: this.state.validation })),
            this.state.status === 'ORDERED' &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/poNumber', labelContent: 'PO Number' },
                            React.createElement(Input, { onChange: function (_, data) { return _this.setState({ poNumber: data.value }); }, placeholder: 'PO#', type: "text", value: this.state.poNumber })),
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/supplier', labelContent: 'Supplier' },
                            React.createElement(Select, { options: this.props.suppliers.map(function (s) { return ({ text: s, value: s }); }), placeholder: 'Supplier', onChange: function (_, data) { return _this.setState({ supplier: data.value }); }, value: this.state.supplier || '', clearable: true })))),
            this.state.status === 'RECEIVED' &&
                React.createElement(Grid, { columns: 2 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/poNumber', labelContent: 'PO Number' },
                                React.createElement(Input, { onChange: function (_, data) { return _this.setState({ poNumber: data.value }); }, placeholder: 'PO#', type: "text", value: this.state.poNumber, disabled: true })),
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/supplier', labelContent: 'Supplier' },
                                React.createElement(Select, { options: this.props.suppliers.map(function (s) { return ({ text: s, value: s }); }), placeholder: 'Supplier', onChange: function (_, data) { return _this.setState({ supplier: data.value }); }, value: this.state.supplier || '', clearable: true, disabled: true })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/yield', labelContent: 'Yield' },
                                React.createElement(Input, { onChange: this.onYieldChange, placeholder: 0, value: this.state.yield, disabled: !!this.props.probeLot.params.lotYield }))),
                        this.props.probeLot.params.lotYield &&
                            React.createElement(Grid.Column, null,
                                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/currentInventory', labelContent: 'CurrentInventory' },
                                    React.createElement(Input, { onChange: this.onCurrentInventoryChange, placeholder: 0, value: this.state.currentInventory }))))),
            React.createElement(Grid, { columns: 2 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Checkbox, { checked: this.state.deactivated, label: "Deactivate", onChange: this.onDeactivateChange })),
                    this.state.deactivated &&
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/reasonForDeactivation', labelContent: 'Reason for Deactivation' },
                                React.createElement(Input, { onChange: this.onReasonForDeactivationExplanationChange, value: this.state.reasonForDeactivation })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Save Edits', labelPosition: 'left', onClick: this.submit, positive: true })))));
    };
    return EditUnpurifiedProbeLotModal;
}(React.PureComponent));
export default EditUnpurifiedProbeLotModal;
//# sourceMappingURL=EditUnpurifiedProbeLotModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditUnpurifiedProbeLotModal.js
// module id = 1248
// module chunks = 0